import { AxiosRequestConfig } from 'axios';

import {
  IAnnouncement,
  IAppVersion,
  IAppVersionParams,
  IAsset,
  IAssetParams,
  ICompany,
  IContact,
  IFeatureAnnouncement,
  IGetAnnouncementsParams,
  IUpdateAnnouncementParams
} from '@aqx-core/common/api/config';
import { request } from '@aqx-core/common/request';

export default {
  annoncements: () => request.get<IAnnouncement[]>('/api/config/v1/announcement'),
  assets: (params: IAssetParams) => request.get<IAsset[]>('/api/config/v1/asset', { params }),
  companyProfile: (signal?: AbortSignal) => request.get<ICompany>('/api/config/v1/company', { signal }),
  companyProfileAfterLogin: (signal?: AbortSignal) => request.get<ICompany>('/api/config/v1/company/user', { signal }), // After login called this api instead of company
  companyContact: () => request.get<IContact>('/api/config/v2/company/contact'),
  appVersion: (params: IAppVersionParams) => request.get<IAppVersion>('/api/config/v1/app-version', { params }),
  fetchFeatureAnnouncements: (params?: IGetAnnouncementsParams, config?: AxiosRequestConfig) =>
    request.get<IFeatureAnnouncement[]>('/api/config/v1/feature/announcements', { params, ...config }),
  markFeatureAnnouncementAsSeen: (params: IUpdateAnnouncementParams, config?: AxiosRequestConfig) =>
    request.patch(`/api/config/v1/feature/announcements`, undefined, { params, ...config })
};
